import BaseReducer from "./BaseReducer";

class ConfirmInputModalReducer extends BaseReducer {
  domain = "Modals";
  type = "ConfirmInputModal";

  initialState = {
    open: false,
    title: "Confirmation",
    message: "Are you sure you wish to continue?",
    confirmInput: "",
  };
}

const reducer = new ConfirmInputModalReducer();

export default reducer;
